/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/

module.exports = {
  /* 00. Generados por KC */
  "home.leaderboard": "Players leaderboard",

  /* 01.General */
  "general.copyright": "KingConf 2020, all rights reserved",
  "general.loading": "Loading, please wait...",

  /* 02.User Login, Logout, Register */
  "user.login-title": "Login",
  "user.sign-out": "Sign Out",
  "user.register": "Register",
  "user.forgot-password": "Forgot Password",
  "user.email": "E-mail",
  "user.password": "Password",
  "user.forgot-password-question": "Forgot password?",
  "user.fullname": "Full Name",
  "user.login-button": "LOGIN",
  "user.register-button": "REGISTER",
  "user.reset-password-button": "RESET",
  "user.buy": "BUY",
  "user.username": "Username",
  "user.new-password-again": "New Password Again",
  "user.new-password": "New Password",
  "user.reset-password": "Reset Password",
  "user.profile": "Profile",
  "user.certificate": "Certificate",
  "user.accessCode": "Access code",
  "user.company": "Company",
  "user.earnedPoints": "Earned points",
  "user.update": "Update",
  "user.role": "Role",
  "user.website": "Website",
  "user.about": "About",

  /* 03.Menu */
  "menu.app": "Home",
  "menu.home": "Home",
  "menu.attendees": "Attendees",
  "menu.channels": "Channels",
  "menu.programme": "Programme",
  "menu.speakers": "Speakers",
  "menu.sponsors": "Sponsors",
  "menu.makemeeting": "Request a meeting",
  "menu.mymeetings": "My meetings",
  "menu.forum": "Forum",
  "menu.liveStream": "Live",
  "menu.dashboards": "Dashboards",
  "menu.start": "Start",
  "menu.second-menu": "Second Menu",
  "menu.second": "Second",
  "menu.ui": "UI",
  "menu.charts": "Charts",
  "menu.chat": "Chat",
  "menu.survey": "Survey",
  "menu.todo": "Todo",
  "menu.search": "Search",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",
  "menu.fair": "Exhibition",
  "menu.brounds": "Business Rounds",

  /* 04.Error Page */
  "pages.error-title": "Ooops... looks like an error occurred!",
  "pages.error-code": "Error code",
  "pages.go-back-home": "GO BACK HOME",
  "bsrounds.mediaErrors": "We found the following error: ",


  /* 03.Menu */
  "menu.default": "Default",
  "menu.analytics": "Analytics",
  "menu.ecommerce": "Ecommerce",
  "menu.content": "Content",
  "menu.pages": "Pages",
  "menu.data-list": "Data List",
  "menu.thumb-list": "Thumb List",
  "menu.image-list": "Image List",
  "menu.details": "Details",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.forgot-password": "Forgot Password",
  "menu.error": "Error",
  "menu.applications": "Applications",
  "menu.alerts": "Alerts",
  "menu.badges": "Badges",
  "menu.buttons": "Buttons",
  "menu.cards": "Cards",
  "menu.carousel": "Carousel",
  "menu.collapse": "Collapse",
  "menu.dropdowns": "Dropdowns",
  "menu.editors": "Editors",
  "menu.form-layouts": "Form Layouts",
  "menu.form-components": "Form Components",
  "menu.form-validations": "Form Validations",
  "menu.form-wizard": "Form Wizard",
  "menu.icons": "Icons",
  "menu.input-groups": "Input Groups",
  "menu.jumbotron": "Jumbotron",
  "menu.modal": "Modal",
  "menu.navigation": "Navigation",
  "menu.popover-tooltip": "Popover & Tooltip",
  "menu.sortable": "Sortable",
  "menu.tables": "Tables",
  "menu.menu": "Menu",
  "menu.subhidden": "Subhidden",
  "menu.hidden": "Hidden",
  "menu.visible": "Visible",
  "menu.maps": "Maps",
  "menu.landingpage": "Landing Page",
  "menu.multipage-home": "Multipage Home",
  "menu.singlepage-home": "Singlepage Home",
  "menu.about": "About",
  "menu.auth-login": "Auth Login",
  "menu.auth-register": "Auth Register",
  "menu.reset-password": "Reset Password",
  "menu.blog": "Blog",
  "menu.blog-list": "Blog List",
  "menu.blog-detail": "Blog Detail",
  "menu.careers": "Careers",
  "menu.confirmation": "Confirmation",
  "menu.contact": "Contact",
  "menu.features": "Features",
  "menu.prices": "Prices",
  "menu.videos": "Videos",
  "menu.mailing": "Mailing",
  "menu.invoice": "Invoice",
  "menu.types": "Menu Types",
  "menu.levels": "Menu Levels",
  "menu.third-level-1": "Third Level 1",
  "menu.third-level-2": "Third Level 2",
  "menu.third-level-3": "Third Level 3",
  "menu.faq": "Faq",
  "menu.knowledge-base": "Knowledge Base",
  "menu.authorization": "Authorization",
  "menu.profile": "Profile",
  "menu.product": "Product",
  "menu.miscellaneous": "Miscellaneous",
  "menu.portfolio": "Portfolio",
  "menu.social": "Social",
  "menu.details-alt": "Details Alt",
  "menu.forms": "Forms",
  "menu.components": "Components",
  "menu.layouts": "Layouts",
  "menu.validations": "Validations",
  "menu.wizard": "Wizard",
  "menu.posters": "Posters",
  "menu.attendee-list": "Attendees",
  "menu.forums": "Forums",

  /* 04.Dashboards */
  "dashboards.event-information": "Event information",
  "dashboards.sponsors-home": "Sponsors",
  "dashboards.zoom-meeting-home": "Meeting Information",
  "dashboards.sponsors-next-event": "Next event",
  "dashboards.live-stream": "Live Streaming",
  "dashboards.event-wall": "Event wall",
  "dashboards.event-wall-add-image": "Add image..",
  "dashboards.event-wall-comment": "Comment",
  "dashboards.event-wall-search": "Search",
  "dashboards.write-something": "Write something...",
  "dashboards.write-something-live": "Leave you live comment",
  "dashboards.event-wall-post": "Post",
  "dashboards.event-wall-no-more-posts": "You have seen all posts!",
  "dashboards.event-wall-report": "Report",
  "dashboards.event-wall-report-confirm": "Confirm",
  "dashboards.event-wall-report-text": "Are you sure you want to report it?",
  "dashboards.comment-live": "Comment live",
  "dashboards.leave-question": "Leave a question",
  "dashboards.schedule": "Schedule",
  "dashboards.pending-orders": "Pending Orders",
  "dashboards.completed-orders": "Completed Orders",
  "dashboards.refund-requests": "Refund Requests",
  "dashboards.new-comments": "New Comments",
  "dashboards.sales": "Sales",
  "dashboards.orders": "Orders",
  "dashboards.refunds": "Refunds",
  "dashboards.recent-orders": "Recent Orders",
  "dashboards.product-categories": "Product Categories",
  "dashboards.cakes": "Cakes",
  "dashboards.tickets": "Tickets",
  "dashboards.calendar": "Calendar",
  "dashboards.best-sellers": "Best Sellers",
  "dashboards.website-visits": "Website Visits",
  "dashboards.unique-visitors": "Unique Visitors",
  "dashboards.this-week": "This Week",
  "dashboards.last-week": "Lat Week",
  "dashboards.this-month": "This Month",
  "dashboards.conversion-rates": "Conversion Rates",
  "dashboards.per-session": "Per Session",
  "dashboards.profile-status": "Profile Status",
  "dashboards.payment-status": "Payment Status",
  "dashboards.work-progress": "Work Progress",
  "dashboards.tasks-completed": "Tasks Completed",
  "dashboards.payments-done": "Payments Done",
  "dashboards.order-stock": "Order - Stock",
  "dashboards.categories": "Categories",
  "dashboards.quick-post": "Quick Post",
  "dashboards.title": "Title",
  "dashboards.goToRoom": "Go to room",
  "dashboards.noActsToShow": "No activities to show",
  "dashboards.trackSearch": "Search by Track",
  "dashboards.typeSearch": "Search by Type",

  "dashboards.room": "Room",
  "dashboards.act-track": "Track",
  "dashboards.act-type": "Type",
  "dashboards.speaker-activities": "Speaker Activities:",
  "dashboards.content": "Content",
  "dashboards.category": "Category",
  "dashboards.save-and-publish": "Save and Publish",
  "dashboards.top-viewed-posts": "Top Viewed Posts",
  "dashboards.posts": "Posts",
  "dashboards.pending-for-publish": "Pending for publish",
  "dashboards.users": "Users",
  "dashboards.on-approval-process": "On approval process",
  "dashboards.alerts": "Alerts",
  "dashboards.waiting-for-notice": "Waiting for notice",
  "dashboards.files": "Files",
  "dashboards.pending-for-print": "Pending for print",
  "dashboards.logs": "Logs",
  "dashboards.gogo": "GOGO",
  "dashboards.magic-is-in-the-details": "MAGIC IS IN THE DETAILS",
  "dashboards.yes-it-is-indeed": "Yes, it is indeed!",
  "dashboards.advanced-search": "Advanced Search",
  "dashboards.toppings": "Toppings",
  "dashboards.type": "Type",
  "dashboards.keyword": "Keyword",
  "dashboards.search": "Search",
  "dashboards.top-rated-items": "Top Rated Items",
  "dashboards.see-poster": "SEE POSTER",
  "dashboards.close-poster": "Close Poster",
  "dashboards.download-poster": "Download Poster",
  "dashboards.poster-heading": "Content",
  "dashboards.poster-expvideo": "Explanation Video",
  "dashboards.poster-description": "Summary",
  "dashboards.loading": "Loading..",
  "dashboards.staticPage-more": "Read more..",
  "dashboards.staticPage-back": "Return",
  "dashboards.no-rooms": "No rooms available",
  "dashboards.seeChildActs": "See child activities",
  "dashboards.hideChildActs": "Hide child activities",
  "dashboards.liveRoom": "LIVE",
  "dashboards.seeModal": "WATCH",
  "dashboards.openModalPresentation": "Presentation",
  "dashboards.name": "Name",
  "dashboards.country": "Country",
  "dashboards.phone": "Mobile Phone",
  "dashboards.company": "Company",
  "dashboards.sessionPartakers": "Participating in this activity:",
  "dashboards.close": "Close",
  "dashboards.send-message": "Send Message",
  "dashboards.SessionNextEventCountDown-nextEventTimeRemain": "In",
  "dashboards.SessionNextEventCountDown-nextEvent": "Next event In",
  "dashboards.SessionNextEventCountDown-day": "Day",
  "dashboards.SessionNextEventCountDown-days": "Days",
  "dashboards.addEventToCalendar": "Add to your calendar",
  "dashboards.description-online": "View description",

  /* 05.Pages */
  "pages.add-new": "ADD NEW",
  "pages.add-new-modal-title": "Add New Item",
  "pages.display-options": "Display Options",
  "pages.orderby": "Order By : ",
  "pages.product-name": "Product Name",
  "pages.category": "Category",
  "pages.description": "Description",
  "pages.status": "Status",
  "pages.cancel": "Cancel",
  "pages.submit": "Submit",
  "pages.delete": "Delete",
  "pages.another-action": "Another action",
  "pages.actions": "ACTIONS",
  "pages.header": "Header",
  "pages.details": "DETAILS",
  "pages.orders": "ORDERS",
  "pages.rating": "Rating",
  "pages.price": "Price",
  "pages.ingredients": "Ingredients",
  "pages.is-vegan": "Is Vegan",
  "pages.order-status": "Order Status",
  "pages.bake-progress": "Bake Progress",
  "pages.popularity": "Popularity",
  "pages.comments": "Comments",
  "pages.mailing-info":
    "Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.",
  "pages.invoice-info":
    "Invoice template has an inline styled version for usage outside of the project as well as React version.",
  "pages.react-version": "React Version",
  "pages.inline-version": "Inline Styled Html Version",
  "pages.like": "Like",
  "pages.likes": "Likes",
  "pages.details-title": "Details",
  "pages.comments-title": "Comments",
  "pages.questions-title": "Questions",
  "pages.similar-projects": "Similar Projects",
  "pages.send": "Send",
  "pages.addComment": "Add a comment",
  "pages.location": "Location",
  "pages.responsibilities": "Responsibilities",
  "pages.photos": "Photos",
  "pages.who-to-follow": "Who to Follow",
  "pages.follow": "FOLLOW",
  "pages.followers": "FOLLOWERS",
  "pages.recent-posts": "Recent Posts",
  "pages.profile": "PROFILE",
  "pages.friends": "FRIENDS",
  "pages.images": "IMAGES",
  "pages.purchase": "PURCHASE",
  "pages.price.developer": "DEVELOPER",
  "pages.price.team": "TEAM",
  "pages.price.enterprise": "ENTERPRISE",
  "pages.price.twofactorauthentication": "Two factor authentication",
  "pages.price.teampermissions": "Team permissions",
  "pages.price.245Support": "24/5 Support",
  "pages.price.247Support": "24/7 Support",
  "pages.price.useractionsauditlog": "User actions audit log",
  "pages.prices.featurecomparison": "Feature Comparison",
  "pages.prices.pricecomparison": "Price Comparison",

  /* 06.Applications */

  /* 06.01.Chat */
  "chat.messages": "Messages",
  "chat.contacts": "Contacts",
  "chat.saysomething": "Say something..",

  /* 06.02.Survey */
  "survey.delete": "Delete",
  "survey.edit": "Edit",
  "survey.add-new": "ADD NEW",
  "survey.add-new-title": "Add New Survey",
  "survey.title": "Title",
  "survey.category": "Category",
  "survey.label": "Label",
  "survey.status": "Status",
  "survey.cancel": "Cancel",
  "survey.submit": "Submit",
  "survey.another-action": "Another action",
  "survey.display-options": "Display Options",
  "survey.orderby": "Order By : ",
  "survey.all-surveys": "All Surveys",
  "survey.completed-surveys": "Completed Surveys",
  "survey.categories": "Categories",
  "survey.active-surveys": "Active Surveys",
  "survey.labels": "Labels",

  /* 06.03.Todo */
  "todo.add-new": "ADD NEW",
  "todo.add-new-title": "Add New Todo",
  "todo.title": "Title",
  "todo.detail": "Detail",
  "todo.category": "Category",
  "todo.label": "Label",
  "todo.status": "Status",
  "todo.cancel": "Cancel",
  "todo.submit": "Submit",
  "todo.action": "Action",
  "todo.another-action": "Another action",
  "todo.display-options": "Display Options",
  "todo.orderby": "Order By : ",
  "todo.all-tasks": "All Tasks",
  "todo.pending-tasks": "Pending Tasks",
  "todo.completed-tasks": "Completed Tasks",
  "todo.categories": "Categories",
  "todo.labels": "Labels",

  /* 07.UI */

  /* 07.01.Alerts */
  "alert.rounded": "Rounded Alert",
  "alert.react-notifications": "React Notifications",
  "alert.outline": "Outline",
  "alert.primary": "Primary",
  "alert.secondary": "Secondary",
  "alert.info": "Info",
  "alert.success": "Success",
  "alert.warning": "Warning",
  "alert.error": "Error",
  "alert.filled": "Filled",
  "alert.primary-text": "This is a primary alert—check it out!",
  "alert.secondary-text": "This is a secondary alert—check it out!",
  "alert.success-text": "This is a success alert—check it out!",
  "alert.danger-text": "This is a danger alert—check it out!",
  "alert.warning-text": "This is a warning alert—check it out!",
  "alert.info-text": "This is a info alert—check it out!",
  "alert.light-text": "This is a light alert—check it out!",
  "alert.dark-text": "This is a dark alert—check it out!",
  "alert.default": "Default Alert",
  "alert.dismissing": "Dismissing Alert",
  "alert.dismissing-text":
    "Holy guacamole! You should check in on some of those fields below.",
  "alert.dismissing-without-animate-text":
    "I am an alert and I can be dismissed without animating!",

  /* 07.02.Badges */
  "badge.sizes": "Sizes",
  "badge.colors": "Colors",
  "badge.outline": "Outline",
  "badge.links": "Links",
  "badge.counter-badges": "Counter Badges",
  "badge.bootstrap-default": "Bootstrap Default",
  "badge.primary": "Primary",
  "badge.secondary": "Secondary",
  "badge.success": "Success",
  "badge.danger": "Danger",
  "badge.warning": "Warning",
  "badge.info": "Info",
  "badge.light": "Light",
  "badge.dark": "Dark",

  /* 07.03.Buttons */
  "button.default": "Bootstrap Default",
  "button.colors": "Colors",
  "button.rounded": "Rounded",
  "button.outline": "Outline",
  "button.states": "States",
  "button.sizes": "Sizes",
  "button.button-groups": "Button Groups",
  "button.large-button": "Large Button",
  "button.small-button": "Small Button",
  "button.extra-small-button": "Extra Small Button",
  "button.block-button": "Block Button",
  "button.active": "Active",
  "button.disabled": "Disabled",
  "button.basic": "Basic",
  "button.toolbar": "Toolbar",
  "button.nesting": "Nesting",
  "button.vertical-variation": "Vertical Variation",
  "button.checkbox-radio-button": "Checkbox and Radio Button",
  "button.checkbox": "Checkbox",
  "button.radio": "Radio",
  "button.radio-button": "Radio Button",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.success": "Success",
  "button.danger": "Danger",
  "button.warning": "Warning",
  "button.info": "Info",
  "button.light": "Light",
  "button.dark": "Dark",
  "button.states-text":
    "This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.",
  "button.click-here": "Click Here",
  "button.states-text-alternate":
    "This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.",
  "button.primary-link": "Primary Link",
  "button.link": "Link",
  "button.primary-button": "Primary Button",
  "button.button": "Button",
  "button.left": "Left",
  "button.middle": "Middle",
  "button.right": "Right",
  "button.dropdown": "Dropdown",
  "button.dropdown-link": "Dropdown Link",
  "button.back-to-programme": "Back to Programme",
  /* Botones extra KingConf */
  buttons: {
    send: "Send",
    close: "Close",
    accept: "Accept",
    cancel: "Cancel"
  },
  "button.send": "Send",
  "button.close": "Close",
  "button.accept": "Accept",
  "button.cancel": "Cancel",
  /* Botones extra KingConf */
  /* 07.04.Cards */
  "cards.icon-card": "Icon Card",
  "cards.image-card": "Image Card",
  "cards.image-overlay-card": "Image Overlay Card",
  "cards.image-card-list": "Image Card List",
  "cards.tab-card": "Tab Card",
  "cards.user-card": "User Card",
  "cards.sponsor-card-name": "Name",
  "cards.sponsor-card-desc": "Description",
  "cards.sponsor-card-locat": "Location",
  "cards.sponsor-card-contact": "Contact",

  /* 07.05.Carousel */
  "carousel.basic": "Carousel Basic",
  "carousel.single": "Carousel Single",
  "carousel.without-controls": "Carousel Without Controls",

  /* 07.06.Charts */
  "charts.line": "Line Chart",
  "charts.polar": "Polar Chart",
  "charts.area": "Area Chart",
  "charts.scatter": "Scatter Chart",
  "charts.bar": "Bar Chart",
  "charts.radar": "Radar Chart",
  "charts.pie": "Pie Chart",
  "charts.doughnut": "Doughnut Chart",
  "charts.shadow": "Shadow",
  "charts.no-shadow": "No Shadow",

  /* 07.07.Collapse */
  "collapse.basic": "Basic",
  "collapse.toggle": "Toggle",
  "collapse.accordion": "Accordion",
  "collapse.controlled": "Controlled",
  "collapse.uncontrolled": "Uncontrolled",

  /* 07.08.Dropdowns */
  "dropdowns.basic": "Basic",
  "dropdowns.controlled": "Controlled",
  "dropdowns.uncontrolled": "Uncontrolled",
  "dropdowns.dropdown": "Dropdown",
  "dropdowns.header": "Header",
  "dropdowns.action": "Action",
  "dropdowns.another-action": "Another Action",
  "dropdowns.right": "Right",
  "dropdowns.left": "Left",
  "dropdowns.drop-directions": "Drop Directions",
  "dropdowns.dropright": "Dropright",
  "dropdowns.dropleft": "Dropleft",
  "dropdowns.small-button": "Small Button",
  "dropdowns.large-button": "Large Button",
  "dropdowns.sizing": "Sizing",
  "dropdowns.split-button": "Split Button Dropdowns",
  "dropdowns.dropup": "Dropup",

  /* 07.09.Editors */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "Quill Standard",
  "editors.quill-bubble": "Quill Bubble",

  /* 07.10.Forms */
  "forms.basic": "Basic",
  "forms.email": "E-mail",
  "forms.email-muted": "We'll never share your email with anyone else.",
  "forms.password": "Password",
  "forms.password-confirm": "Confirm Password",
  "forms.submit": "Submit",
  "forms.horizontal": "Horizontal",
  "forms.radios": "Radios",
  "forms.first-radio": "First radio",
  "forms.second-radio": "Second radio",
  "forms.third-radio-disabled": "Third disabled radio",
  "forms.checkbox": "Checkbox",
  "forms.signin": "Sign in",
  "forms.top-labels-over-line": "Top Labels Over Line",
  "forms.tags": "Tags",
  "forms.date": "Date",
  "forms.state": "State",
  "forms.top-labels-in-input": "Top Labels In Input",
  "forms.email-u": "E-MAIL",
  "forms.password-u": "PASSWORD",
  "forms.tags-u": "TAGS",
  "forms.date-u": "DATE",
  "forms.state-u": "STATE",
  "forms.grid": "Form Grid",
  "forms.address": "Address",
  "forms.address2": "Address 2",
  "forms.city": "City",
  "forms.city-message": "Please select a city!",
  "forms.state-message": "Please select a state!",
  "forms.zip": "Zip",
  "forms.signup": "Signup",
  "forms.inline": "Inline",
  "forms.validation-availity": "Availity Reactstrap Validation",
  "forms.validation-formik": "Formik Validation",
  "forms.default": "Default",
  "forms.firstname": "First name",
  "forms.firstname-message": "Please enter your first name!",
  "forms.lastname": "Last name",
  "forms.lastname-message": "Please enter your last name!",
  "forms.name": "Name",

  /* 07.11.Form Components */
  "form-components.custom-inputs": "Custom Inputs",
  "form-components.checkboxes": "Checkboxes",
  "form-components.radios": "Radios",
  "form-components.inline": "Inline",
  "form-components.react-select": "React Select",
  "form-components.state-single": "State Single",
  "form-components.state-multiple": "State Multiple",
  "form-components.react-autosuggest": "React Autosuggest",
  "form-components.date-picker": "Date Picker",
  "form-components.date": "Date",
  "form-components.date-range": "Date Range",
  "form-components.date-with-time": "Date with Time",
  "form-components.embedded": "Embedded",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "Drop Files Here",
  "form-components.tags": "Tags",
  "form-components.switch": "Switch",
  "form-components.primary": "Primary",
  "form-components.secondary": "Secondary",
  "form-components.primary-inverse": "Primary Inverse",
  "form-components.secondary-inverse": "Secondary Inverse",
  "form-components.slider": "Slider",
  "form-components.double-slider": "Double Slider",
  "form-components.single-slider": "Single Slider",
  "form-components.rating": "Rating",
  "form-components.interactive": "Interactive",
  "form-components.readonly": "Readonly",
  "form-components.type-a-cake": "Type a Cake",
  "form-components.start": "Start",
  "form-components.end": "End",
  "form-components.tables": "Tables",
  /* 07.12.Icons */
  "icons.simplelineicons": "Simple Line Icons",
  "icons.iconsmind": "Iconsmind Icons",

  /* 07.13.Input Groups */
  "input-groups.basic": "Basic",
  "input-groups.sizing": "Sizing",
  "input-groups.small": "Small",
  "input-groups.default": "Default",
  "input-groups.large": "Large",
  "input-groups.checkboxes-and-radios": "Checkboxes and radios",
  "input-groups.multiple-inputs": "Multiple Inputs",
  "input-groups.first-and-last-name": "First and last name",
  "input-groups.multiple-addons": "Multiple Addons",
  "input-groups.button-addons": "Button Addons",
  "input-groups.button": "Button",
  "input-groups.buttons-with-dropdowns": "Buttons with Dropdowns",
  "input-groups.dropdown": "Dropdown",
  "input-groups.header": "Header",
  "input-groups.action": "Action",
  "input-groups.another-action": "Another Action",
  "input-groups.custom-select": "Custom Select",
  "input-groups.options": "Options",
  "input-groups.choose": "Choose...",
  "input-groups.custom-file-input": "Custom File Input",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "Hello, world!",
  "jumbotron.lead":
    "This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.",
  "jumbotron.lead-detail":
    "It uses utility classes for typography and spacing to space content out within the larger container.",
  "jumbotron.learn-more": "Learn more",

  /* 07.15.Modal */
  "modal.basic": "Basic",
  "modal.modal-title": "Modal title",
  "modal.launch-demo-modal": "Launch Demo Modal",
  "modal.scrolling-long-content": "Scrolling Long Content",
  "modal.backdrop": "Backdrop",
  "modal.backdrop-value": "Backdrop value",
  "modal.right-modal": "Right Modal",
  "modal.launch-right-modal": "Launch Right Modal",
  "modal.nested-modal": "Nested Modal",
  "modal.size": "Size",
  "modal.launch-large-modal": "Launch Large Modal",
  "modal.launch-small-modal": "Launch Small Modal",

  /* 07.16.Navigation */
  "nav.basic": "Nav Basic",
  "nav.active": "Active",
  "nav.disabled": "Disabled",
  "nav.disabled-link": "Disabled Link",
  "nav.link": "Link",
  "nav.longer-link": "Longer nav link",
  "nav.another-link": "Another Link",
  "nav.right": "Right",
  "nav.dropdown": "Dropdown",
  "nav.header": "Header",
  "nav.action": "Action",
  "nav.another-action": "Another Action",
  "nav.horizontal-alignment": "Nav Horizontal Alignment",
  "nav.vertical-alignment": "Nav Vertical Alignment",
  "nav.pills": "Nav Pills",
  "nav.fill-justify": "Nav Fill and Justify",
  "nav.pills-dropdowns": "Nav Pills with Dropdowns",
  "nav.pagination-basic": "Pagination Basic",
  "nav.pagination-sizing": "Pagination Sizing",
  "nav.large": "Large",
  "nav.small": "Small",
  "nav.center": "Center",
  "nav.pagination-alignment": "Pagination Alignment",
  "nav.breadcrumb-basic": "Breadcrumb Basic",

  /* 07.17.Popover & Tooltip */
  "popover-tooltip.popover": "Popover",
  "popover-tooltip.tooltip": "Tooltip",

  /* 07.18.Sortable */
  "sortable.columns": "Sorting Columns",
  "sortable.basic": "Basic",
  "sortable.handles": "Handles",

  /* 07.19.Maps */
  "maps.google": "Google",
  "maps.yandex": "Yandex",

  /* 07.20.Tables */
  "table.bootstrap-tables": "Bootstrap Tables",
  "table.bootstrap-basic": "Basic Table",
  "table.bootstrap-striped": "Striped Rows",
  "table.bootstrap-bordered": "Bordered Table",
  "table.bootstrap-borderless": "Borderless Table",
  "table.bootstrap-hoverable": "Hoverable Rows",
  "table.bootstrap-responsive": "Responsive Table",
  "table.react-tables": "React Tables",
  "table.react-pagination": "Pagination",
  "table.react-scrollable": "Scrollable",
  "table.react-advanced": "Filter, Length and Jump",
  "table.divided": "Divided Table",

  /* 07.21.Wizards */
  "wizard.step-name-1": "Step 1",
  "wizard.step-name-2": "Step 2",
  "wizard.step-name-3": "Step 3",
  "wizard.step-desc-1": "First step description",
  "wizard.step-desc-2": "Second step description",
  "wizard.step-desc-3": "Third step description",
  "wizard.content-1": "Step content for first step.",
  "wizard.content-2": "Step content for second step.",
  "wizard.content-3": "Last step content!",
  "wizard.content-thanks": "Thank You!",
  "wizard.next": "Next",
  "wizard.prev": "Back",
  "wizard.registered": "Your registration completed successfully!",
  "wizard.async": "Async save for 3 seconds!",
  "br.my-pending-answer":
    "You have a meeting request from <b>{firstname} {lastname}</b> that is pending for an answer.",
  "br.their-pending-answer":
    "You have a request pending for confirmation from <b>{firstname} {lastname}</b>.",
  "br.their-pending-answer-mymeetings":
    "You have a meeting request from <b>{firstname} {lastname}</b> ",
  "br.confirmed-meeting-mymeetings":
    "You have a confirmed meeting  with <b>{firstname} {lastname}</b> ",
  "br.another-meeting":
    "You have a request pending for confirmation from <b>{firstname} {lastname}</b>",
  "br.my-meeting-request-mymeetings":
    "You made a request to <b>{firstname} {lastname}</b> that is pending for an answer",
  "br.time-slot-available": "Both are available at this time!",
  "br.requester-message": "You wrote:",
  "br.time-slot-not-available": "<b>{name} </b> is not available at this time",
  "br.time-slot-available-mymeetings": "Time slot available!",
  "br.request-meeting": "Request a meeting",
  "br.timezone-clarification":
    "* All the times are  expressed locale as your browser configuration GMT{time}",
  "br.meeting-clarification":
    "* go to “My meetings” section in order to accept or decline the request",
  "br.start-meeting": "Join meeting",
  "br.accept-meeting": "Accept meeting",
  "br.reject-meeting": "Reject meeting",
  "br.meeting-stablished":
    "You have a confirmed meeting with <b>{firstname} {lastname}</b>",
  "br.no-slots-available": "We're sorry, but we couldn't find any overlapping free time slots for you and the person you requested.",
  "br.no-slots-available-today": "We're sorry, but we couldn't find any overlapping free time slots for you and the requested person on the selected day.",
  "br.no-participants-match": "Unfortunately, we couldn't find any participants that match your search criteria.",
  "br.error-loading-my-meetings": "Unfortunately, we couldn't load the calendar. Please try again later or contact the event organizer for assistance.",
  "br.no-longer-available": "We apologize, but the requested time slot is no longer available. Please select a different time slot that works for both parties.",
  "br.request-succesful": "Your meeting request has been successfully sent.",
  "br.your-agenda": "My meetings",
  "br.block-slot": "Block time",
  "br.unblock-slot": "Unblock time",
  "br.cancel-meeting": "Cancel meeting",
  "br.time-slot-blocked": "This time slot has been blocked by you",
  "br.leave-meeting": "Leave meeting",
  "br.waiting-person": "waiting for the other person to join...",
  "br.sharing-screen": "You are sharing your screen",
  "br.waitingForCounterpart": "Waiting for the other participant...",

  "networking.write-message": "Write your message",
  "zoom-meeting-info": "Join the meeting on ",
  "login.access-code": "Access code",
  "login.submit": "Sign in",
  "login.register": "Sign up",
  "login.welcome-text": "WELCOME TO ",
  "login.not-open-yet": "The event is not open to the public yet",
  "login.placeholder-email": "Registered email",
  "login.placeholder-codigo-acceso": "Access code delivered by email",
  "login.invalid-credentials": "Invalid credentials",
  "speakers.search": "Search an speaker",

};
